import React, { useState, useRef } from "react";
import "../../assets/css/sign.css";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import logo from "../../assets/AdityaBirlaGroupLogoVector.svg";
import mainBanner from "../../assets/MainBanner.svg";
import { useNavigate, Link } from "react-router-dom";

import eyevisible from "../../assets/eyeicons/visibility.svg";
import visibility_off from "../../assets/eyeicons/visibility_off.svg";
// import Loader from "../Components/Loader";
import Loader from "../../Components/LoaderAndSpinner/Loader";

const SignIn = () => {
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	// const [emailError, setEmailError] = useState("");
	// const [passwordError, setPasswordError] = useState("");
	const [loginError, setLoginError] = useState("");

	const [errors, setErrors] = useState({});

	const [loading, setLoading] = useState(false);
	const [passwordVisible, setPasswordVisible] = useState(false);

	const navigate = useNavigate();
	const passwordRef = useRef(null);

	const handleSubmit = async (event) => {
		event.preventDefault();
		setLoading(true);
		setErrors({});

		// Store the full email in session storage
		sessionStorage.setItem("email", email);

		// Append domain to the email
		const formattedEmail = `${email}@adityabirla.com`;

		const data = { email: formattedEmail, password };


		try {
			const response = await fetch(
				`${process.env.REACT_APP_BASE_API_URL1}/api/v1/login`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify(data),
				}
			);

			if (!response.ok) {
				const errorData = await response.json();


				const errorMessaged = errorData.message;

				setErrors(errorData.errors || {});
				toast.error(errorMessaged);
				setLoading(false);
				return;
			}


			setLoading(false);
			navigate("/auth/otpVerification");
		} catch (error) {
			console.error("Error occurred:", error);
			setLoginError("An error occurred. Please try again later.");
			toast.error("Error occurred");
		} finally {
			setLoading(false); // Set loading state to false after API call is complete
		}
	};

	const handleEmailKeyDown = (event) => {
		if (event.key === "Enter") {
			event.preventDefault();
			passwordRef.current.focus();
		}
	};

	const handlePasswordKeyDown = (event) => {
		if (event.key === "Enter") {
			event.preventDefault();
			handleSubmit(event);
		}
	};

	const currentYear = new Date().getFullYear();

	return (
		<>
			{loading ? <Loader /> : ""}
			<div className="container bg-white">
				<div>
					<div className="row signIn-card">
						<div className="col-lg-6 p-0 pt-4 col-md-12 px-4  mb-4 resp-img">
							<img src={mainBanner} alt="bg-image" className="resp-img-img" />
							<img src={logo} className="banner-logo desktop-logo" alt="logo" />

							<div className="banner-text-container">
								<h1 className="banner-text1">Asset Taxonomy Management</h1>
								<h3 className="banner-text2">ATM - version 1.0</h3>
							</div>
						</div>
						<div className="col-lg-6 col-md-12  p-0 px-4 signin-col align-content-center ">
							<h2>Sign In</h2>
							<p>Enter your details to sign in to your account</p>
							<form
								className="signin-form needs-validation"
								onSubmit={handleSubmit}
								noValidate
							>
								<div
									className="d-flex flex-column"
									style={{ marginBottom: "16px", position: "relative" }}
								>
									<label htmlFor="email" className="signin-form-label">
										Email Id
									</label>
									<input
										id="email"
										name="email"
										placeholder="Enter your email"
										className={`signin-form-input  ${errors.email ? "is-invalid" : ""
											}`}
										value={email}
										onChange={(e) => setEmail(e.target.value)}
										onKeyDown={handleEmailKeyDown}
										// style={{ borderRadius: "12px" }}
										autoComplete="off"
									/>
									<p className="email-p">@adityabirla.com</p>
									{errors.email && (
										<div className="invalid-feedback">{errors.email}</div>
									)}
								</div>
								<div
									className="d-flex flex-column"
									style={{ marginBottom: "16px" }}
								>
									<label htmlFor="password" className="signin-form-label">
										Password
									</label>
									<input
										id="password"
										name="password"
										placeholder="Enter your password"
										className={`signin-form-input ${errors.password ? "is-invalid" : ""
											}`}
										type={passwordVisible ? "text" : "password"}
										value={password}
										onChange={(e) => setPassword(e.target.value)}
										onKeyDown={handlePasswordKeyDown}
										ref={passwordRef}
									/>
									<span onClick={() => setPasswordVisible(!passwordVisible)}>
										<img
											className="password-icon"
											src={passwordVisible ? eyevisible : visibility_off}
											alt="password-icon"
										/>
									</span>
									{/* ..
passwordVisible ? {comp26} : "password"
src={comp26}

*/}

									{errors.password && (
										<div className="invalid-feedback">{errors.password}</div>
									)}
								</div>
								<p className="signin-form-fp-text">
									<Link to="/auth/forgetPassword">Forgot Password?</Link>
								</p>
								{loginError && (
									<p className="error-message text-danger">{loginError}</p>
								)}
								<button type="submit" className="signin-form-button">
									SIGN IN
								</button>
							</form>
						</div>
					</div>
					<div className="d-flex justify-content-between align-content-center  px-4  sign-footer-text">
						<p className="w-100">Copyright all rights reserved {currentYear}</p>
						<div className="w-100 d-flex gap-5 justify-content-end sign-footer-text-1 ">
							<p>Terms Of Use</p>
							<p>Privacy Policy</p>
						</div>
					</div>
				</div>
			</div>

			<ToastContainer autoClose={4000} position={"top-right"} />
		</>
	);
};

export default SignIn;
